import { Capacitor } from '@capacitor/core'

import CashMachine from '@/integrations/cashmachine/cashmachine'
import { logger } from '@/monitoring'
import { useUpdateVersion } from '@/plugins/updateVersion'
import { getDeviceInfo } from '@/utils/device'
import { isElectron } from '@/utils/device-type'

import { CapgoUpdater } from './capgo'
import { ElectronUpdater } from './electron'
import { GenericUpdater } from './generic'
import type { Updater } from './updater'

export function getUpdater(): Updater {
  const platform = Capacitor.getPlatform()
  if (isElectron) {
    return new ElectronUpdater()
  } else if (platform === 'ios' || platform === 'android') {
    return new CapgoUpdater()
  }
  return new GenericUpdater()
}

class UpdaterEngine {
  private updater = getUpdater()
  private componentMounted: boolean = false

  constructor() {
    this.componentMounted = false
  }

  notifyAppReady() {
    this.updater.notifyAppReady()
  }

  async checkForUpdates() {
    const device = await getDeviceInfo()
    const isUpdateReady = await this.updater.checkUpdates(device)
    if (isUpdateReady) {
      this.mountUpdateModalComponent()
    }
  }

  private mountUpdateModalComponent() {
    if (this.componentMounted) return
    this.componentMounted = true
    const updateModal = useUpdateVersion()
    updateModal({
      onConfirm: () => this.confirmUpdate()
    })
  }

  async confirmUpdate() {
    if (CashMachine.isEnabled()) {
      try {
        await CashMachine.close()
      } catch {
        logger.warn('Failed to close cash machine')
      }
    }
    await this.updater.installUpdate()
  }
}

export default new UpdaterEngine()
